import request from '@utils/axiosWrapper';
import { ReportWeakAlertParams } from '../types';

/**
 * 上报商家升级引导用户确认
 * @param params 请求参数
 * @return 无
 */
export const reportWeakAlert = (params: ReportWeakAlertParams) =>
    request.get<void>('/gw/version/pc/weakAlertReport', { params });

export default { reportWeakAlert };
